<!-- nav -->
<nav class="navbar navbar-expand navbar-dark bg-dark" *ngIf="user">
    <div class="navbar-nav">
        <a class="nav-item nav-link" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">Home</a>
        <a class="nav-item nav-link" routerLink="/users" routerLinkActive="active">Users</a>

    </div>
</nav>

<!-- main app container -->
<div class="app-container" >
    <alert></alert>
    <router-outlet></router-outlet>
</div>

<!-- credits
<div class="text-center mt-4">
    <p>
     <a href="https://jasonwatmore.com/post/2020/04/28/angular-9-user-registration-and-login-example-tutorial" target="_top">Angular 9 - User Registration and Login Example & Tutorial</a> 
    </p>
    <p  style="color:rgb(36, 3, 3)">
       <strong> Powered By  </strong><a href="https://insolutionsglobal.com/" target="_top" style="color:rgb(36, 3, 3)">In-Solutions Global Limited</a>
    </p>
</div> -->
